import { post, del, get, patch } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR from 'swr'
import { handleApiResponse } from './api_util';


async function assignUserToCase(orgID,caseID,userID){
    const payload={
        apiName: 'LivisiblyOrgApi',
        path: `orgs/${orgID}/cases/${caseID}/users/${userID}/assign`,
      }

      const restOperation = patch(payload);


      const response = await restOperation.response;
      return processResponse(response)
  }

  async function assignUsersToCase(orgID,caseID,userList){
    const payload={
        apiName: 'LivisiblyOrgApi',
        path: `orgs/${orgID}/cases/${caseID}/users/assign`,
        options: {
          body: {
            user_list: userList,
          }
        }
      }

      const restOperation = patch(payload);


      const response = await restOperation.response;
      return processResponse(response)
  }

  async function getCaseUsers(orgID, caseID){

     const payload={
      apiName: 'LivisiblyOrgApi',
      path: `orgs/${orgID}/cases/${caseID}/users`

    }

    const restOperation = get(payload);


    const response = await restOperation.response;

    return processResponse(response)
  }

  async function getCaseUser(orgID,caseID,userID){
    const payload={
      apiName: 'LivisiblyOrgApi',
      path: `orgs/${orgID}/cases/${caseID}/users/${userID}`
    }

    const restOperation = get(payload);


    const response = await restOperation.response;
    return processResponse(response)
  }

  async function unassignUserFromCase(orgID,caseID,userID){
    const payload={
      apiName: 'LivisiblyOrgApi',
      path: `orgs/${orgID}/cases/${caseID}/users/${userID}/unassign`,
      }
    const restOperation = patch(payload);

    const response = await restOperation.response;
    return processResponse(response)
  }

  async function unassignUsersFromCase(orgID,caseID,userList){
    const payload={
      apiName: 'LivisiblyOrgApi',
      path: `orgs/${orgID}/cases/${caseID}/users/unassign`,
      options: {
        body: {
          user_list: userList,
        }
      }
    }
    const restOperation = patch(payload);

    const response = await restOperation.response;
    return processResponse(response)
  }


// Create org user
export function useAssignUserToCase() {
    return async (orgID,caseID,userID) => {
      try {
        const response = await assignUserToCase(orgID,caseID,userID);
        return handleApiResponse(['CASEUSERS',orgID,caseID],'userID',response, 'create');
      } catch (error) {
        console.error('Error assigning user to case:', error);
        throw error;
      }
    };
  }

export function useAssignUsersToCase() {
    return async (orgID,caseID,userList) => {
      try {
        const response = await assignUsersToCase(orgID,caseID,userList);
        return handleApiResponse(['CASEUSERS',orgID,caseID],'userID',response, 'create');
      } catch (error) {
        console.error('Error assigning users to case:', error);
        throw error;
      }
    };
  }

  export function useGetCaseUsers(orgID,caseID,shouldFetch=true){
    const result = useSWR(
      shouldFetch ? ['CASEUSERS',orgID,caseID] : null,
      (path) => getCaseUsers(orgID,caseID)
    );
    return result;
  }

  export function useGetCaseUser(orgID,caseID,userID, shouldFetch=true){
    const result = useSWR(
      shouldFetch ? [['ORGUSERS', orgID,caseID], userID] : null,
      ([path, userID]) => getCaseUser(orgID, caseID, userID)
    );
    return result;
  }

  export function useUnassignUserFromCase() {
    return async (orgID,caseID,userID) => {
      try {
        const response = await unassignUserFromCase(orgID,caseID,userID);
        return handleApiResponse(['CASEUSERS',orgID,caseID],'userID',response, 'delete');
      } catch (error) {
        console.error('Error unassigning user from case:', error);
        throw error;
      }
    };
  }

  export function useUnassignUsersFromCase() {
    return async (orgID,caseID,userList) => {
      try {
        const response = await unassignUsersFromCase(orgID,caseID,userList);
        return handleApiResponse(['CASEUSERS',orgID,caseID],'userID',response, 'delete');
      } catch (error) {
        console.error('Error unassigning users from case:', error);
        throw error;
      }
    };
  }